"use client";

import React, { useEffect, useState } from "react";
import { ExplorerContent } from "@/features/Explorer/ExplorerContent.tsx";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { TabPanel } from "@/features/Explorer/TabPanel.tsx";
import { EditorPanel } from "@/features/AudioWorkstation/components/AudioEditorTabs/EditorTabPane/EditorPanel.tsx";
import { FlexBox } from "@/common/components/Box/FlexBox.tsx";
import { Folder } from "@mui/icons-material";
import useRecordingSegment from "@/common/hooks/useRecordingSegment.ts";
import useCurrentExplorerItem from "@/common/hooks/useCurrentExplorerItem.ts";
import { AppHashTag } from "@/enum/AppHashTag.ts";
import clsx from "clsx";
import styles from "@/common/scss/template.module.scss";
import { StyledTab } from "@/features/Explorer/StyledTab.tsx";
import EditIcon from "@mui/icons-material/Edit";
import { useMediaQuery } from "@mui/material";
import { Theme } from "@mui/material/styles";

export const EXPLORER_ROOT = "EXPLORER_ROOT";

const Explorer = () => {
  const [currentTab, setCurrentTab] = useState(0);
  const [recordingSegment] = useRecordingSegment();
  const currentExplorerItem = useCurrentExplorerItem();

  const isMediumScreen = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  useEffect(() => {
    const updateTabBasedOnHash = () => {
      const hash = window.location.hash;
      if (hash === AppHashTag.EDITOR) {
        setCurrentTab(1);
      } else if (hash === AppHashTag.POINTS) {
        setCurrentTab(2);
      } else {
        setCurrentTab(0);
      }
    };

    updateTabBasedOnHash();
    window.addEventListener('hashchange', updateTabBasedOnHash);

    return () => {
      window.removeEventListener('hashchange', updateTabBasedOnHash);
    };
  }, []);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setCurrentTab(newValue);

    if (newValue === 0) {
      window.location.hash = AppHashTag.EXPLORER;
    } else if (newValue === 1) {
      window.location.hash = AppHashTag.EDITOR;
    } else if (newValue === 2) {
      window.location.hash = AppHashTag.POINTS;
    }
  };


  return (
    <FlexBox
      className={clsx({
        [styles.MainContainer]: true,
      })}
    >
      <FlexBox
        sx={{
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
        }}
      >
        {/* Tabs */}
        {
          currentExplorerItem
          && Object.keys(currentExplorerItem.track?.segments || {}).length > 0
          && <FlexBox sx={{ flexGrow: 1 }}>
            {isMediumScreen ? (
              <Tabs
                value={currentExplorerItem ? currentTab : 0}
                onChange={handleTabChange}
              >
                <StyledTab
                  wrapped={true}
                  iconPosition={"start"}
                  icon={<Folder fontSize="small" />}
                />
                {currentExplorerItem && (
                  <StyledTab
                    wrapped={true}
                    iconPosition={"start"}
                    icon={
                      <EditIcon
                        color={recordingSegment ? "error" : "inherit"}
                        fontSize="small"
                      />
                    }
                  />
                )}
              </Tabs>
            ) : (
              <Tabs
                value={currentExplorerItem ? currentTab : 0}
                onChange={handleTabChange}
              >
                <Tab
                  iconPosition={"start"}
                  label={"Explorer"}
                  icon={<Folder fontSize="small" />}
                />
                {currentExplorerItem && (
                  <Tab
                    iconPosition={"start"}
                    label={"Editor"}
                    icon={
                      <EditIcon
                        color={recordingSegment ? "error" : "inherit"}
                        fontSize="small"
                      />
                    }
                  />
                )}
              </Tabs>
            )}
          </FlexBox>
        }

        {/* Right-Side Controls */}
        {/*<FlexBox sx={{ justifyContent: "flex-end", flexShrink: 0 }}>
          <ButtonWithIcon
            icon={<Upload />}
            tooltip={"Upload"}
            onClick={uploadAudio}
            size="small"
            sx={{ ml: 2, p: 0.8 }}
          />

          {currentExplorerItem && <ButtonWithIcon
            sx={{ mr: 1 }}
            onClick={handleToggleEditor}
            icon={<AudioLines />}
            tooltip={editorIsOpen ? "Close editor" : "Open editor"}
            isActive={editorIsOpen}
          />}
          <ButtonWithIcon
            sx={{ mr: 1 }}
            onClick={handleCreateNewFolder}
            icon={<CreateNewFolder />}
            tooltip={"Create folder"}
          />
          <ExplorerSearchInput />
        </FlexBox>*/}
      </FlexBox>

      <FlexBox
        className={clsx({
          [styles.TabsWrapper]: true,
        })}
      >
        <TabPanel value={currentTab} index={0}>
          <ExplorerContent />
        </TabPanel>

        {currentExplorerItem && (
          <TabPanel value={currentTab} index={1}>
            <EditorPanel />
          </TabPanel>
        )}
      </FlexBox>
    </FlexBox>
  );
};

export default Explorer;
